// extracted by mini-css-extract-plugin
export default {"Discounts_icons_container":"MainPageBenefits_Discounts_icons_container__ARPsF","Plane_icon":"MainPageBenefits_Plane_icon__+5pfG"};